import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { AssessmentQuestionManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/assessment-questions")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <AssessmentQuestionManagement />
    </RouteGuard>
  ),
});
